import axios from "axios";

function credentialAxios() {
  const Axios = axios.create({
    withCredentials: true,
  });

  // Interceptor para agregar el token justo antes de cada request
  Axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      } else {
        delete config.headers["Authorization"];
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  Axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 503 || error.response?.status === 401) {
        console.log(
          "Session expired or unauthorized, redirecting to login Axios"
        );
        localStorage.removeItem("token");
        localStorage.setItem("sessionExpired", "true");

        window.location.href = "/login";
      } else {
        return Promise.reject(error);
      }
    }
  );

  return Axios;
}

const Axios = credentialAxios();
export default Axios;
